import { useTranslation } from 'react-i18next'

import B2becInfoLayout from '@/components/B2becInfoLayout/B2becInfoLayout'
import useBreadcrumbs from '@/hooks/useBreadcrumbs'
import useDocumentTitle from '@/hooks/useDocumentTitle'

import SparePartsFinderInput from './components/SparePartsFinderInput'
import styles from './SparePartsFinder.module.scss'

const emptyBreadcrumbs = []

const SparePartsFinder = ({ breadcrumbs = emptyBreadcrumbs }) => {
  const { t } = useTranslation()

  useBreadcrumbs(breadcrumbs)
  useDocumentTitle('pageTitle.sparePartsFinder')

  return (
    <B2becInfoLayout className={styles.SparePartsFinder}>
      <B2becInfoLayout.Title title={t('pageTitle.sparePartsFinder')} />
      <B2becInfoLayout.Content>
        <div className={styles.description}>
          <h2>{t('sparePartsFinder.onlineShopSpareParts')}</h2>
          {t('sparePartsFinder.onlineShopSparePartsDescription')}
        </div>
        <div className={styles.description}>
          <h2>{t('sparePartsFinder.findProduct')}</h2>
          {t('sparePartsFinder.findProductDescription')}
        </div>
        <SparePartsFinderInput />
      </B2becInfoLayout.Content>
    </B2becInfoLayout>
  )
}

export default SparePartsFinder
